import React from 'react'
import './splash.css'
import Loader from '../../assets/lumoz.png'

const splash = () => {
  return (
    <div className='splash-screen'>
      <img src={Loader}></img>
      
    </div>
  )
}

export default splash
